import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { SystemsInventoryRequest } from '../../class/systems-inventory-request';

@Injectable()
export class SystemsInventoryRequestService extends WebService  {

  public getSystemsInventoryRequest(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append('_page', String(page));
    } else {
      params.append('_page', '1');
    }

    if (per_page !== null && per_page !== undefined) {
      params.append('_limit', String(per_page));
    } else {
      params.append('_limit', '10');
    }

    if (sort !== null && sort !== undefined) {
      params.append('_sort', String(sort));
    }

    if (query !== null && query !== undefined && query !== '') {
      params.append('_q', String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    params.append('_with', String('one_tracking_info.assigned_to_by,one_tracking_info.venue,one_tracking_info.destination'));

    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/systems-inventory?${params}`, options);
  }

  public newSystemsInventoryRequest(body: Object): Observable<Response> {
    return this.http.post( `${this.apiUrl}/systems-inventory`, JSON.stringify(body) , { headers: this.headers } );
  }

  public updateSystemsInventoryRequest(id: number, body: Object): Observable<Response> {
    return this.http.patch( `${this.apiUrl}/systems-inventory/${id}`, JSON.stringify(body) , { headers: this.headers } );
  }

  public deleteSystemsInventoryRequest(id: number): Observable<Response> {
    return this.http.delete( `${this.apiUrl}/systems-inventory/${id}`, { headers: this.headers } );
  }

  public infoSystemsInventoryRequest(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('_with', String('equipment_tracking'));


    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/systems-inventory/${id}?${params}`, options);
  }

  public calculateUtilLife(purchase_date: Date): { message: string, state: string, class: string } {
    // Validamos si la fecha de compra es válida
    if (!purchase_date) {
      return {
        message: 'No hay fecha de compra diligenciada.',
        state: 'Error',
        class: 'alert-danger'
      };
    }

    const CurrentDate = new Date(); // Fecha actual del dispositivo
    const PurchaseDate = new Date(purchase_date); // Fecha de compra recibida

    const diffInTime = CurrentDate.getTime() - PurchaseDate.getTime();

    // Convertimos la diferencia de tiempo en milisegundos a días
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    const years = Math.floor(diffInDays / 365);
    const months = Math.floor((diffInDays % 365) / 30);
    const days = Math.floor((diffInDays % 365) % 30);

    let result = 'El equipo lleva ';

    if (years > 0) {
      result += `${years} ${years === 1 ? 'año' : 'años'}`;
    }

    if (months > 0) {
      if (years > 0) result += `, `;
      result += `${months} ${months === 1 ? 'mes' : 'meses'}`;
    }

    if (days > 0) {
      if (years > 0 || months > 0) result += `, `;
      result += `${days} ${days === 1 ? 'día' : 'días'}`;
    }

    result += ' de vida útil.';

    // Ahora calculamos el state del equipo y asignamos una clase CSS
    let state: string = '';
    let clase: string = '';

    if (years < 2) {
      state = 'Bien';
      clase = 'alert-success';
    } else if (years >= 2 && years < 3) {
      state = 'Medio';
      clase = 'alert-warning';
    } else if (years >= 4) {
      state = 'Mal';
      clase = 'alert-danger';
    }

    return { message: result, state, class: clase };
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/systems-inventory-request/systems-inventory-request.service.ts